import type { RefObject } from "react";
import React from "react";

import type { DownloadableTableData } from "../DownloadTable";

export const useTableExtractor = ({
  tableRef,
  enabled,
}: {
  tableRef: RefObject<HTMLTableElement | null>;
  enabled: boolean;
}) => {
  const [table, setTable] = React.useState<DownloadableTableData | null>(null);

  React.useEffect(() => {
    if (tableRef.current && enabled) {
      // Extract table rows
      const rows = Array.from(tableRef.current.querySelectorAll("tr"));
      const headers = Array.from(rows[0].querySelectorAll("th, td")).map(
        (header) => header.textContent?.trim() ?? "",
      );

      // Extract data rows
      const data = rows.slice(1).map((row) => {
        const cells = Array.from(row.querySelectorAll("td"));
        return headers.reduce<Record<string, string | null>>(
          (acc, header, index) => {
            acc[header] = cells[index]?.textContent?.trim() ?? null;
            return acc;
          },
          {},
        );
      });

      setTable({
        columns: headers,
        data,
      });
    }
  }, [enabled, tableRef]);

  return table;
};
